import ReactDOM from "react-dom";
import App from "./App";
import "./global-styles/colors.scss";
import "./global-styles/fonts.scss";
import "./global-styles/common.scss";
import "./recurly.scss";
import "./index.scss";
import React from "react";
import DIContext, { DIContainer } from "./core/di";
import getDependencies, { Envs } from "./wired-dependencies";
import CONFIG from "./core/consts/config";

// Get DI configuration for current environment
const diContainer: DIContainer = getDependencies(CONFIG.APP_ENV as Envs);

// Conditionally import dev tools only in non-production
// Using REACT_APP_ENV at build time ensures production builds exclude this code
let DevTools: React.ComponentType | null = null;

if (process.env.REACT_APP_ENV !== 'production') {
  // Dynamic import to ensure tree-shaking in production builds
  const devToolsModule = require('./dev/dev-tools');
  DevTools = devToolsModule.DevTools;
}

const AppConfigured = () => {
  return (
    <DIContext.Provider value={diContainer}>
      <App />
      {DevTools && <DevTools />}
    </DIContext.Provider>
  );
};

ReactDOM.render(<AppConfigured />, document.getElementById("root"));
